import { Box, Paper, Skeleton, Tab, Tabs, Typography } from "@mui/material";
import React from "react";

import { useMcsContext } from "./MCS.context";
import { useNavigate } from "react-router-dom";
import PlantModuleNav from "../../../../../components/PlantModuleNav";
import TabPanelFormat from "../../../../../components/widgets/TabPanelFormat";
import { getMCSTabs } from "./MCSTabs";
import {
  getHashdataUrl,
  setHashUrl,
} from "../../../../../components/Tabs/Utils/hashFunctions";
import FactoryIcon from "@mui/icons-material/Factory";
import useStandaloneView from "../../../../../hooks/useStandaloneView";

export default function Main() {
  const { mcsCurrentTab, setMcsCurrentTab, plant, mrqList } = useMcsContext();
  const navigate = useNavigate();
  const standalone = useStandaloneView();
  const tabs = getMCSTabs(mrqList);
  const navLabel = "mcs-tab";

  // const fullHash = window.location.hash;
  // React.useEffect(() => {
  //   const hashValue = getHashdata(fullHash, navLabel);
  //   const tabIndex = tabs.findIndex(
  //     (tab) => tab.label === decodeURIComponent(hashValue)
  //   );

  //   // console.log({ tabIndex });
  //   // if hash value for tabs is present, set it as currentTab
  //   if (tabIndex !== -1) {
  //     setMcsCurrentTab(tabIndex);
  //   }
  //   // if its not present, but there is some existing hash value, add this to the hash value
  //   else if (fullHash)
  //     window.location.hash = fullHash + "&" + navLabel + "=" + tabs[0].label;
  //   // if not either, start a new hash
  //   else window.location.hash = navLabel + "=" + tabs[0].label;
  // }, []);

  React.useEffect(() => {
    const hashValue = getHashdataUrl(navLabel);

    const tabIndex = tabs.findIndex(
      (tab) => tab.label === decodeURIComponent(hashValue),
    );

    if (tabIndex !== -1) {
      setMcsCurrentTab(tabIndex);
    } else {
      setHashUrl(navLabel, tabs[0].label);
    }
  }, []);

  const handleChange = (_, newValue) => {
    setMcsCurrentTab(newValue);
    setHashUrl(navLabel, tabs[newValue].label);
  };

  // const handleChange = (event, newValue) => {
  //   // console.log("CHNGE");
  //   setMcsCurrentTab(newValue);

  //   setHash(fullHash, navLabel, tabs[newValue].label);
  // };

  return (
    <Paper sx={{ width: "100%", display: "flex", position: "relative" }}>
      <Box {...{ width: "100%", overflow: "auto" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "space-between",
            px: 2,
            pt: 1,
            pb: 0,
          }}
        >
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{
              color: "text.main",
              bgcolor: (theme) => `${theme.palette.primary.main}14`,
              px: 1.5,
              py: 0.5,
              borderRadius: 1,
              borderLeft: "4px solid",
              borderColor: "primary.main",
            }}
          >
            PMS (Procurement Management System)
          </Typography>

          <Box
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              bgcolor: "action.hover",
              display: "flex",
              alignItems: "center",
              gap: 1,
              minWidth: 180,
              justifyContent: "center",
            }}
          >
            <FactoryIcon fontSize="small" color="primary" />
            <Box>
              <Box
                sx={{
                  fontSize: "0.7rem",
                  color: "text.secondary",
                  lineHeight: 1,
                }}
              >
                Plant
              </Box>
              {plant?.name ? (
                <Box sx={{ fontWeight: 700, fontSize: "0.95rem" }}>
                  {plant?.name || "-"}
                </Box>
              ) : (
                <Box mt={0.5}>
                  <Skeleton variant="rectangular" width={160} height={22} />
                </Box>
              )}
            </Box>
            {!standalone && <PlantModuleNav plantId={plant.id} compact />}
          </Box>
        </Box>
        {!standalone && (
          <Tabs
            sx={{}}
            value={mcsCurrentTab}
            onChange={handleChange}
            orientation={"horizontal"}
          >
            {tabs.map((tab, i) => {
              return <Tab label={tab.label} value={i} />;
            })}
          </Tabs>
        )}

        <TabPanelFormat {...tabs[mcsCurrentTab].panelProps}>
          {tabs[mcsCurrentTab].panel}
        </TabPanelFormat>
      </Box>
    </Paper>
  );
}
